import React from 'react';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { SecurityVerification } from 'components/newAccountSteps/profileSteps/securityVerification/SecurityVerification';
import { OTPTransferView } from 'routes/formsView/OTPTransferView/OTPTransferView';
import { TRANSFER_MVP_STEP } from 'constants/featureFlagging';
import { connect } from 'react-redux';
import { ACTIVATED, STAND_BY, SUCCESS } from 'constants/statusProcess';
import { DocumentationInfo } from 'components/documentationInfo/DocumentationInfo/documentationInfo';
import { EnrolmentSuccess } from 'components/EnrolmentSuccess/EnrolmentSuccess';

const STATUSES_WITH_DIFFERENT_VIEW = [SUCCESS, STAND_BY, ACTIVATED];

const OtpContainerComponent = ({ flags, userProfile }) => {
    if (STATUSES_WITH_DIFFERENT_VIEW.includes(userProfile.status)) {
        const VIEW_BY_STATUS = {
            [SUCCESS]: <EnrolmentSuccess investmentType={userProfile.investmentType} />,
            [STAND_BY]: <DocumentationInfo />,
            [ACTIVATED]: <EnrolmentSuccess investmentType={userProfile.investmentType} />,
        };

        return <div>{VIEW_BY_STATUS[userProfile.status]}</div>;
    }

    return flags.get(TRANSFER_MVP_STEP) ? <SecurityVerification /> : <OTPTransferView />;
};

export const OtpContainer = connect(state => ({ userProfile: state.userProfile }))(
    withFeatureToggling(OtpContainerComponent)
);
